// @flow
/** @jsx isolateComponent */

import _ from 'lodash';
import { Fragment } from 'react';
import { type HOC, pure } from 'recompose';

import { Button } from '@zapier/common-components';
import { isolateComponent } from '@zapier/common-utils';

import FilterRuleEditor from 'app/beta-editor/components/formatic/FilterRuleEditor';
import { FAIL_STATUSES } from 'app/beta-editor/utils/RuleUtils';

import type { Field } from 'app/beta-editor/types';

type Rule = {
  id: string,
  key: string,
  value: string,
  match: string,
};

type FilterGroupProps = {
  config: {},
  field: Field,
  groupId: number,
  rules: Array<Rule>,
  shouldShowTestResults: boolean,
  isLastGroup: boolean,
  ruleResultsById: {},
  onAction: () => void,
  onAddRule: (id: number) => void,
  onAddGroup: () => void,
  onChangeRule: () => void,
  onDeleteRule: () => void,
};

const ButtonRowCss = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  marginTop: 20,
  width: '150px',
};

const FilterGroup = (props: FilterGroupProps) => {
  const { rules, ruleResultsById } = props;
  const editors = rules.map((rule, i) => {
    const ruleResults = ruleResultsById[rule.id] || {};
    const ruleFailed = _.includes(FAIL_STATUSES, ruleResults.status);
    return (
      <FilterRuleEditor
        config={props.config}
        field={props.field}
        key={rule.id}
        onAction={props.onAction}
        onChange={props.onChangeRule}
        onDelete={props.onDeleteRule}
        ruleFailed={ruleFailed}
        ruleId={rule.id}
        ruleKey={rule.key}
        ruleMatch={rule.match}
        ruleNumber={i + 1}
        ruleValue={rule.value}
      />
    );
  });

  return (
    <Fragment>
      {editors}
      <div css={ButtonRowCss}>
        <Button
          isSlim={true}
          kind="secondary"
          onClick={() => props.onAddRule(props.groupId)}
          size="small"
        >
          + AND
        </Button>
        {props.isLastGroup && (
          <Button
            isSlim={true}
            kind="secondary"
            onClick={props.onAddGroup}
            size="small"
          >
            + OR
          </Button>
        )}
      </div>
    </Fragment>
  );
};

const enhancedFilterGroup: HOC<*, FilterGroupProps> = pure;

export default enhancedFilterGroup(FilterGroup);
